import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';

import './App.css';
import 'animate.css/animate.compat.css';
import Footer from './components/Footer';
import TopBar from './components/TopBar';
import { ConsultButton, ContactButton } from './components/FloatingButton';
import Banner from './components/Banner';
import VideoCarousel from './components/VideoCarousel';
import Introduction from './components/Introduction';
import Feature from './components/Feature';
import Case from './components/Case';
import MediaArticle from './components/MediaArticle';
import Solution from './components/Solution';
import FAQ from './components/FAQ';

function App() {
    return (
        <div className="App">
            <ConfigProvider
                theme={{
                    token: {
                        fontFamily: "GenSenRounded"
                    }
                }}
            >
                <ConsultButton/>
                <ContactButton/>
                <TopBar/>
                <div className='content'>
                    <Banner/>
                    <VideoCarousel/>
                    <Introduction/>
                    <Feature/>
                    <Case/>
                    <MediaArticle/>
                    <Solution/>
                    <FAQ/>
                </div>
                <Footer/>
            </ConfigProvider>
        </div>
    );
}

export default App;
